import React, { useEffect, useState } from "react";
import axios from "axios";

const API_TOKEN = process.env.REACT_APP_API_TOKEN;
const API = process.env.REACT_APP_API_FOLDER;

function textToHtml(text) {
  return String(text || "")
    .split(/\n{2,}/)
    .map((p) => `<p>${p.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[c])).replace(/\n/g, "<br>")}</p>`)
    .join("");
}

function FieldNoteSubmit() {
  const [artforms, setArtforms] = useState([]);
  const [selected, setSelected] = useState(new Set());
  const [values, setValues] = useState({ name: "", email: "", title: "", proposal: "", biog: "", link: "", notes: "", rights: false, company: "" });
  const [images, setImages] = useState([]);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    axios.get(`${API}get_artforms/`, { headers: { "X-API-TOKEN": API_TOKEN } })
      .then(({ data }) => setArtforms(Array.isArray(data) ? data : []))
      .catch(() => setArtforms([]));
  }, []);

  const update = (key, value) => setValues((v) => ({ ...v, [key]: value }));
  const toggleArtform = (artform) => setSelected((current) => {
    const next = new Set(current);
    next.has(artform) ? next.delete(artform) : next.add(artform);
    return next;
  });

  const submit = async (event) => {
    event.preventDefault(); setBusy(true); setErrors([]);
    try {
      const form = new FormData();
      form.append("name", values.name); form.append("email", values.email); form.append("title", values.title);
      form.append("proposal", textToHtml(values.proposal)); form.append("biog", textToHtml(values.biog));
      form.append("link", values.link); form.append("notes_to_camp", values.notes); form.append("rights_confirmed", values.rights ? "1" : "0"); form.append("company", values.company);
      [...selected].forEach((a) => form.append("artforms[]", a)); images.slice(0, 3).forEach((file) => form.append("images[]", file));
      const { data } = await axios.post(`${API}fieldnote_submit/`, form, { headers: { "X-API-TOKEN": API_TOKEN } });
      if (data?.error) throw Object.assign(new Error(data.error), { response: { data } });
      setDone(true);
    } catch (err) {
      const responseErrors = err?.response?.data?.errors;
      setErrors(Array.isArray(responseErrors) ? responseErrors : [err?.response?.data?.error || err.message || "Submission failed."]);
    } finally { setBusy(false); }
  };

  if (done) return <section className="fieldnote-workspace-page pt-110 section-bottom-pad"><div className="container"><div className="fieldnote-public-form"><h1>Thank you</h1><p>Your Field Notes proposal has been received. CAMP will contact you after it has been reviewed.</p></div></div></section>;

  return <section className="fieldnote-workspace-page pt-110 section-bottom-pad"><div className="container"><div className="fieldnote-public-form">
    <h1>Submit a Field Note</h1><p className="fieldnote-form-intro">Send us an idea, draft or short sample. You do not need to prepare the finished piece at this stage.</p>
    {errors.length > 0 && <div className="alert alert-danger"><ul className="mb-0">{errors.map((e, i) => <li key={i}>{e}</li>)}</ul></div>}
    <form onSubmit={submit}>
      <div className="fieldnote-form-grid"><label>Name<input className="form-control" required maxLength="200" value={values.name} onChange={(e) => update("name", e.target.value)} /></label><label>Email<input className="form-control" required type="email" maxLength="200" value={values.email} onChange={(e) => update("email", e.target.value)} /></label></div>
      <label>Working title<input className="form-control" required maxLength="200" value={values.title} onChange={(e) => update("title", e.target.value)} /></label>
      <label>Proposal / sample text<textarea className="form-control" required rows="12" value={values.proposal} onChange={(e) => update("proposal", e.target.value)} /><small>Tell us what the piece is about, or paste an early draft.</small></label>
      <label>Short biography<textarea className="form-control" required rows="5" value={values.biog} onChange={(e) => update("biog", e.target.value)} /></label>
      <label>Website / profile <span>(optional)</span><input className="form-control" value={values.link} onChange={(e) => update("link", e.target.value)} /></label>
      <fieldset><legend>Artform / subject</legend><div className="fieldnote-artform-grid">{artforms.map((art) => <label key={art} className="fieldnote-artform-choice"><input type="checkbox" checked={selected.has(art)} onChange={() => toggleArtform(art)} /> {art}</label>)}</div></fieldset>
      <label>Reference images <span>(optional, maximum 3)</span><input className="form-control" type="file" accept="image/jpeg,image/png,image/webp" multiple onChange={(e) => setImages(Array.from(e.target.files || []).slice(0, 3))} /></label>
      <label>Anything else CAMP should know? <span>(optional)</span><textarea className="form-control" rows="4" value={values.notes} onChange={(e) => update("notes", e.target.value)} /></label>
      <label className="fieldnote-rights"><input type="checkbox" required checked={values.rights} onChange={(e) => update("rights", e.target.checked)} /> I confirm that I have the right to submit this text and any images supplied.</label>
      <label className="fieldnote-honeypot" aria-hidden="true">Company<input tabIndex="-1" autoComplete="off" value={values.company} onChange={(e) => update("company", e.target.value)} /></label>
      <button className="btn btn-primary btn-lg" disabled={busy || selected.size === 0}>{busy ? "Sending…" : "Submit proposal"}</button>
    </form>
  </div></div></section>;
}
export default FieldNoteSubmit;
